// import axios from 'axios';
const axios = require('axios');

const apiUrl = 'http://api.elcoma.com.br/api';

var skippable;

//Get all the clients
async function getClients(){
  let clients = [];

  try{
    await axios.get(`${apiUrl}/clients?filter={"fields":["name", "group", "controller_id", "idVagalox", "Floors", "offline", "radio_prefix"]}`).then(({data}) => {
      clients = data.map(client => (Object.assign(client, {group: client.group.text})));
    })

    return clients;
  } catch (e){
    console.log(e)
    return clients;
  }
}

//Get all the client which has map page
async function getClientsWithMapPage(){
  let clients = [];


  try{

    await axios.get(`${apiUrl}/clients?filter={"where":{"coordinates":{"neq":null}},"fields":["name", "group", "idVagalox", "controller_id",  "radio_prefix", "coordinates"]}`).then(({data}) => {
      clients = data.map(client => (Object.assign(client, {group: client.group.text})));
    })

    // clients.forEach(client => {
    //     client.idVagalox = client.idVagalox.toLowerCase().replace(/-/gi, "_");
    // })
  } catch (err) {
    console.log(err)
  }
  return clients;
}

//Get all the radios
async function getRadios(token){
  let radios = [];
  let access_token = token;

  await axios.get(`${apiUrl}/radios?filter={"fields": ["clientname","radio_prefix","offline", "name"]}&access_token=${access_token}`).then(({data}) => {
    radios = data;
  })

  return radios;
}

//Test the 'devices sensored' panel at the maps page
async function testMapSensor(clients){
  var clientsWithSensorError = [];

  for(let client of clients){
    const { idVagalox, clientname } = client;

    const url = `${apiUrl}/ap_sensors?filter={"fields": ["Total_Stations"], "where": {"client": "${idVagalox.length > 0 ? idVagalox : clientname}"}, "order": "ts DESC", "limit": 1}`

    await axios.get(url).then(({data}) => {
      if(data.length === 0){
        client.sensor = "Falha ao sensoriar dispositivos";
        clientsWithSensorError.push(client);
      }else{
        client.sensor = "OK";
        clientsWithSensorError.push(client);
      }
    }).catch((error) => {
      client.sensor = "Falha ao realizar a requisição do sensoriamento";
      clientsWithSensorError.push(client);
    })
  }

  return clientsWithSensorError;
}

//Test the 'devices connected' panel at the maps page
async function testMapConnected(clients){
  var clientsWithConnectError = [];

  for(let client of clients){
    const { radio_prefix } = client;

    const url = `${apiUrl}/status_temps?filter={"limit": 1, "fields": ["totaldevices"], "where": {"clientname": "${radio_prefix}"}, "order": "datetime DESC"}`

    await axios.get(url).then(({data}) => {
      if(data.length === 0){
        client.connect = "Falha ao conectar dispositivo";
        clientsWithConnectError.push(client);
      }else{
        client.connect = "OK";
        clientsWithConnectError.push(client);
      }
    }).catch((error) => {
      client.connect = "Falha ao realizar a requisição do sensoriamento";
      clientsWithConnectError.push(client);
    })
  }

  return clientsWithConnectError;
}

//Test graphic from dashboard
async function testDashboardGraph(){
  var clientsWithError = [];

  var clients = await getClients();

  for(let client of clients){
    const { radio_prefix } = client;

    const url = `${apiUrl}/status_temps?filter={"limit": 1, "fields": ["totaldevices", "totalonline", "clientname"], "where": {"clientname": "${radio_prefix}"}, "order": "datetime DESC"}`

    await axios.get(url).then(({data}) => {
      if(data.length === 0){
        client["error"] = "Falha ao exibir dados";
        clientsWithError.push(client);
      }else{
        client["error"] = "Dashboard com Dados";
        clientsWithError.push(client)
      }
    }).catch((error) => {
      client["error"] = "Falha ao realizar a requisição dos dados";
      clientsWithError.push(client);
    })
  }

  return clientsWithError;
}

//Test for offline radios
async function testOfflineAPsTime(token){
  var offline_aps = [];

  const radios = await getRadios(token);

  skippable = ["JoaquinNogueira","Mezanino-CIO","Recnplay", "BRT", "CampoLimpo","Anchieta", "CorredorCPD", "H1", "DevAP", "SCR", "PC","RecepcaoDiretoria","CorredorComercial","Manutencao","HMulherRecepcao","HCANCORREDORENFER","GerenciaPSO01","HCANSALAREUNIOES","HmulherConsultorios","NeuroAnchieta","HCANCORREDORCONSUL","BoxAdultoPSO01","Informatica","HCANRECEPCAO" ]
  radios.forEach((radio) => {
    const {name, offline} = radio;

    var radio_prefix = name.split('_')[0].toLowerCase();
    if (!!name.split('--')[1]) radio_prefix = name.split('--')[0].toLowerCase();


    if(!skippable.find(rad => rad === radio_prefix) ){

      if(!!offline && offline > 0){
        radio.hours = Math.round(offline/3600);
        offline_aps.push(radio);
      }
    }

  })
  return offline_aps;
}

//Test for offline radios
async function testOfflineAPsInClients(token){
  //data to be returned
  var offline_aps = [];

  const radios = await getRadios(token);
  var clients = await getClients();
  clients.forEach((client) => {
    client["total_aps"] = 0;
    client["offline_aps"] = 0;
  });
  skippable = ["JoaquinNogueira","Mezanino-CIO","Recnplay", "BRT", "CampoLimpo","Anchieta", "CorredorCPD", "H1", "DevAP", "SCR", "PC","RecepcaoDiretoria","CorredorComercial","Manutencao","HMulherRecepcao","HCANCORREDORENFER","GerenciaPSO01","HCANSALAREUNIOES","HmulherConsultorios","NeuroAnchieta","HCANCORREDORCONSUL","BoxAdultoPSO01","Informatica","HCANRECEPCAO" ]
  radios.forEach((radio) => {
    const {name, offline} = radio;
    var radio_prefix = name.split('_')[0].toLowerCase();
    if (!!name.split('--')[1]) radio_prefix = name.split('--')[0].toLowerCase();

    var client_index = clients.findIndex(client => client.radio_prefix === radio_prefix);

    if(!skippable.find(rad => rad === radio_prefix) && client_index >= 0){
      clients[client_index]["total_aps"] = clients[client_index]["total_aps"]+1;

      if(!!offline && offline > 0){
        clients[client_index]["offline_aps"] = clients[client_index]["offline_aps"]+1;
      }s
    }

  })

  clients.forEach(client => {
    if (client["total_aps"] > 0){
      offline_aps.push(client);
    }
  });
  return offline_aps;
}

//Test the dashboard page
async function testDashboardPage(){
  const clients = await getClients();

  await testDashboardGraph(clients);
}

//Test the maps page
async function testMapsPage(){
  const clients = await getClientsWithMapPage();

  var result = [];
  const sensor = await testMapSensor(clients);
  const connect = await testMapConnected(clients);

  result = result.concat(sensor, connect);

  return result;
}

//module.exports = { testDashboardPage, testMapsPage, testOfflineRadios, testOfflineAPsInClients };

export { testDashboardGraph, testMapsPage, testOfflineAPsTime, testOfflineAPsInClients }

/*
As funções 'testMapSensor' e 'testMapConnected' talvez possam ser melhoradas caso utilize Promise.allSettled, mas
está dando erro quando tento usar.
*/



// WEBPACK FOOTER //
// ./src/functions/check.js